import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const STORAGE_KEY = "erp_auth_lang";

const LanguageSwitcher = ({ className = "" }) => {
  const { i18n, t } = useTranslation();

  const resolved = (i18n.resolvedLanguage || i18n.language || "ar").split("-")[0];
  const activeLang = resolved === "ar" ? "ar" : resolved === "fr" ? "fr" : "en";

  const handleChange = (lng) => {
    if (lng === activeLang) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem(STORAGE_KEY, lng);
    } catch {}
  };

  const pillBase =
    "relative inline-flex items-center gap-2 rounded-2xl border border-white/15 bg-white/10 " +
    "backdrop-blur-xl shadow-[0_10px_40px_rgba(0,0,0,0.25)] px-3 py-2";

  const segmentBase =
    "relative z-10 flex items-center gap-1.5 rounded-xl px-3 py-1.5 text-xs font-semibold " +
    "transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-400/70";

  const activeSegment =
    "text-white shadow-[0_10px_25px_rgba(236,72,153,0.25)] " +
    "bg-gradient-to-r from-pink-500/90 to-violet-500/90 border border-white/20";

  const inactiveSegment =
    "text-white/80 hover:text-white hover:bg-white/10 active:scale-[0.98]";

  return (
    <div className={`${pillBase} ${className}`}>
      <div className="flex items-center gap-2 pr-1">
        <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-white/10 border border-white/15">
          <Languages className="h-4 w-4 text-white/90" />
        </div>
        <div className="leading-tight">
          <div className="text-[11px] font-semibold text-white/90">
            {t("common.languageLabel")}
          </div>
        </div>
      </div>

      <div className="inline-flex rounded-2xl bg-black/10 p-1 border border-white/10">
        <button
          type="button"
          onClick={() => handleChange("ar")}
          aria-pressed={activeLang === "ar"}
          className={`${segmentBase} ${activeLang === "ar" ? activeSegment : inactiveSegment}`}
        >
          <span className="opacity-90">{t("common.langAr")}</span>
        </button>

        <button
          type="button"
          onClick={() => handleChange("en")}
          aria-pressed={activeLang === "en"}
          className={`${segmentBase} ${activeLang === "en" ? activeSegment : inactiveSegment}`}
        >
          <span className="opacity-90">{t("common.langEn")}</span>
        </button>

        <button
          type="button"
          onClick={() => handleChange("fr")}
          aria-pressed={activeLang === "fr"}
          className={`${segmentBase} ${activeLang === "fr" ? activeSegment : inactiveSegment}`}
        >
          <span className="opacity-90">{t("common.langFr")}</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
